import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('avatarbutton');

export { TAG_NAME };
